import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const Route = ({ component: Component, isPrivate = false, isPublic = false, ...rest }) => {
	const { isAuth, loading } = useContext(AuthContext);

	// Enquanto a autenticação está sendo resolvida não redirecionamos: só
	// mostramos o loader. Redirecionar durante o loading provoca um "flash"
	// /login → / (home) no boot, pois isAuth ainda é false transitoriamente.
	if (loading) {
		return <BackdropLoading />;
	}

	if (!isAuth && isPrivate) {
		return (
			<>
				{loading && <BackdropLoading />}
				<Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
			</>
		);
	}

	// isPublic = rota acessível independente do estado de login (ex: página
	// pública de agendamento). Diferente de isPrivate=false "puro" (login,
	// signup...), que é só-para-visitante e deve mandar quem já está
	// autenticado de volta para "/".
	if (isAuth && !isPrivate && !isPublic) {
		return (
			<>
				{loading && <BackdropLoading />}
				<Redirect to={{ pathname: "/", state: { from: rest.location } }} />;
			</>
		);
	}

	return (
		<>
			{loading && <BackdropLoading />}
			<RouterRoute {...rest} component={Component} />
		</>
	);
};

export default Route;
